import React from 'react';

import { Grid, Paper, Typography } from '@mui/material';
import { Field } from 'react-final-form';

import { TextField } from 'src/components/finalForm';
import { SxProp } from 'src/types/mui';

type DefaultDisclaimerInputSectionProps = {
  name: string;
  headerText?: string;
  disabled?: boolean;
};

export const DefaultDisclaimerInputSection: React.FC<DefaultDisclaimerInputSectionProps> = ({
  name,
  headerText = 'Employer Disclaimer',
  disabled,
}) => {
  return (
    <Paper sx={disclaimerPaperStyles} variant="outlined" elevation={0}>
      <Grid sx={disclaimerPaperHeaderStyles} size={12}>
        <Typography mb={0.5} fontWeight={600}>
          {headerText}
        </Typography>
        <Typography color="GrayText">Manage the default disclaimer</Typography>
      </Grid>
      <Grid mt={2} size={12}>
        <Field
          name={name}
          component={TextField}
          label="Disclaimer"
          multiline
          fullWidth
          disabled={disabled}
          minRows={3}
        />
      </Grid>
    </Paper>
  );
};

const disclaimerPaperStyles: SxProp = {
  padding: '20px 24px',
  borderRadius: '8px',
  marginTop: 1,
};

const disclaimerPaperHeaderStyles: SxProp = theme => ({
  paddingBottom: '16px',
  borderBottom: `1px solid ${theme.palette.border?.main}`,
});
